import React from 'react'

import { TModalState } from './LegacyBrowserModal'

const TextBody: React.FC<{ browserType: TModalState }> = (props) => {
  return (
    <>
      <p className="text-16 leading-24 sm:text-20 sm:leading-28 mt-16 sm:mt-24">
        Ihr Browser ist veraltet – Shop&#8209;Funktionen evtl. eingeschränkt
      </p>
      <p className="mt-12 text-iron text-12 sm:text-16">
        {props.browserType === 'invalid-ie' && (
          <>
            Sie verwenden noch den Internet Explorer.
            <br />
            Die Verwendung wird von Microsoft nicht mehr empfohlen.
          </>
        )}
        {props.browserType === 'invalid-safari' && (
          <>
            Sie verwenden eine ältere, unsichere Version des Safari Browsers.
            <br />
            Ihre Sicherheit liegt uns am Herzen.
          </>
        )}
        <br />
        Bitte benutzen Sie deshalb einen aktuellen Browser, wie{' '}
        <a
          className="underline whitespace-no-wrap"
          href="https://www.google.com/intl/de_de/chrome/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Chrome
        </a>
        {', '}
        <a
          className="underline whitespace-no-wrap"
          href="https://www.mozilla.org/de/firefox/new/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Mozilla Firefox
        </a>
        {', '}
        <a
          className="underline whitespace-no-wrap"
          href="https://support.apple.com/de-de/HT204416"
          target="_blank"
          rel="noopener noreferrer"
        >
          Safari
        </a>
        {' oder '}
        <a
          className="underline whitespace-no-wrap"
          href="https://www.microsoft.com/de-de/edge"
          target="_blank"
          rel="noopener noreferrer"
        >
          Microsoft Edge
        </a>
        {props.browserType === 'invalid-ie' && (
          <> - für mehr Sicherheit, Geschwindigkeit und Komfort in unserem Online-Shop</>
        )}
        .
        <br />
        Alternativ können Sie jederzeit telefonisch bestellen, unter 0800&nbsp;29&nbsp;888&nbsp;88 (gebührenfrei).
      </p>
    </>
  )
}

export default TextBody
